import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-spinner-1-6-0{display:inline-block;width:90px;height:90px;border-radius:50%;border:4px solid #a6ec55;border-left-color:#73d700;-webkit-animation:spinner-rotate 1s linear infinite;animation:spinner-rotate 1s linear infinite}.hcr-spinner--lg-1-6-0,.hcr-spinner--md-1-6-0,.hcr-spinner--sm-1-6-0,.hcr-spinner--xl-1-6-0,.hcr-spinner--xxl-1-6-0{border-left-color:#5cac00}.hcr-spinner--sm-1-6-0{width:24px;height:24px}.hcr-spinner--md-1-6-0{width:36px;height:36px}.hcr-spinner--lg-1-6-0{width:48px;height:48px}.hcr-spinner--xl-1-6-0{width:72px;height:72px}.hcr-spinner--xxl-1-6-0{width:96px;height:96px}@-webkit-keyframes spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}",
map:{"hcr-spinner":"hcr-spinner-1-6-0","hcr-spinner--sm":"hcr-spinner--sm-1-6-0","hcr-spinner--md":"hcr-spinner--md-1-6-0","hcr-spinner--lg":"hcr-spinner--lg-1-6-0","hcr-spinner--xl":"hcr-spinner--xl-1-6-0","hcr-spinner--xxl":"hcr-spinner--xxl-1-6-0"}};

var bem = Bem('spinner', styles);
var Spinner = function Spinner(_ref) {
  var extraClasses = _ref.extraClasses,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "size"]);

  return React.createElement("div", _extends({
    className: bem.b(size, extraClasses)
  }, rest));
};
Spinner.displayName = 'Spinner';
Spinner.defaultProps = {
  extraClasses: '',
  size: 'xxl'
};
Spinner.propTypes = {
  /** Size of the spinner */
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),

  /** Injection in className */
  extraClasses: PropTypes.string
};
var Spinner$1 = Injecss(Spinner, styles);

export { Spinner$1 as Spinner };
